require('../../../modules/es.array.splice');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').splice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/splice.js
// module id = 686
// module chunks = 0